import { Api } from '../../../../../utility/client';

export const deleteExternalApiKey = async (id: string) => {
  const res = await Api.delete(`/admin/v1/external-api/${id}`);

  return res.data;
};
